"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMenuOrdersResponseAllOfToJSON = exports.GetMenuOrdersResponseAllOfFromJSONTyped = exports.GetMenuOrdersResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetMenuOrdersResponseAllOfFromJSON(json) {
    return GetMenuOrdersResponseAllOfFromJSONTyped(json, false);
}
exports.GetMenuOrdersResponseAllOfFromJSON = GetMenuOrdersResponseAllOfFromJSON;
function GetMenuOrdersResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'menuOrders': (json['menuOrders'].map(_1.MenuOrderFromJSON)),
    };
}
exports.GetMenuOrdersResponseAllOfFromJSONTyped = GetMenuOrdersResponseAllOfFromJSONTyped;
function GetMenuOrdersResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'menuOrders': (value.menuOrders.map(_1.MenuOrderToJSON)),
    };
}
exports.GetMenuOrdersResponseAllOfToJSON = GetMenuOrdersResponseAllOfToJSON;
